import moment from 'moment';

import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import {
  EditDailyDepositFieldEnum as Fields,
  EditDailyDepositAccrualsFieldEnum as AccrualFields,
  EditDailyDepositInfoFieldEnum as InfoFields,
  EditDailyDepositSalesFieldEnum as SalesFields,
} from 'Common/FieldEnum';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { formParseInt, formatToCashAllowNegative } from 'Common/FormHelper';
import { InputMode } from 'Common/FormEnum';

export const EditDailyDepositTabEnum = {
  Sales: 'sales',
  Accruals: 'accruals',
  Summary: 'summary',
};

export const EditDailyDepositTabOptions = [
  { label: 'Sales', value: EditDailyDepositTabEnum.Sales },
  { label: 'Accruals', value: EditDailyDepositTabEnum.Accruals },
  { label: 'Summary', value: EditDailyDepositTabEnum.Summary },
];

export const MealTypeNamesEnum = {
  Breakfast: 'Breakfast',
  Lunch: 'Lunch',
  Other: 'Other',
  Supper: 'Supper',
};
export const MealTypeNames = {
  [MealTypesEnum.Breakfast]: MealTypeNamesEnum.Breakfast,
  [MealTypesEnum.Lunch]: MealTypeNamesEnum.Lunch,
  [MealTypesEnum.Other]: MealTypeNamesEnum.Other,
  [MealTypesEnum.Supper]: MealTypeNamesEnum.Supper,
};

export const StatusNames = {
  '2': 'Free Students',
  '3': 'Reduced Students',
  '4': 'Paid Students',
  '6': 'Teachers',
  '7': 'Adults',
  '8': 'SFS',
  '9': 'Catered',
};

export const SalesMealTypesEnum = {
  Meals: 'R',
  Supplemental: 'S',
};

export const InputTypes = {
  Qty: { name: 'Qty', formatter: formParseInt, mode: InputMode.Integer },
  Sales: {
    name: 'Sales',
    formatter: formatToCashAllowNegative,
    mode: InputMode.Decimal,
  },
};

export const totalReducer = inputType => ({ column, data }) =>
  inputType.formatter(
    data.reduce((sum, val) => sum + Number(val[column.id]), 0)
  );

const type1Statuses = [StatusEnum.Free, StatusEnum.Reduced, StatusEnum.Paid];

export const getDefaultDD = isSupper => {
  var salesArray = [];
  var accrualsArray = [];
  var info = {};

  const mealTypes = isSupper
    ? [MealTypesEnum.Supper]
    : [MealTypesEnum.Breakfast, MealTypesEnum.Lunch, MealTypesEnum.Other];
  const statusArray = [
    StatusEnum.Free,
    StatusEnum.Reduced,
    StatusEnum.Paid,
    StatusEnum.Teacher,
    StatusEnum.Adult,
    StatusEnum.SchoolFoodService,
    StatusEnum.Catering,
  ];

  mealTypes.forEach(type =>
    statusArray.forEach(status => {
      accrualsArray.push(defaultAccrual(type, status));
    })
  );

  Object.values(SalesMealTypesEnum).forEach(type =>
    statusArray.forEach(status => salesArray.push(defaultSale(type, status)))
  );

  info = defaultInfo(isSupper);

  return {
    [Fields.Sales]: salesArray,
    [Fields.Accruals]: accrualsArray,
    [Fields.Info]: info,
  };
};

const defaultAccrual = (type, status) => {
  let accrual = {};
  Object.values(AccrualFields).forEach(field => (accrual[field] = 0));

  accrual[AccrualFields.Status] = parseInt(status, 10);
  accrual[AccrualFields.StatusMerger] = type1Statuses.includes(status) ? 1 : 2;
  accrual[AccrualFields.TypeOfMeal] = type;

  return accrual;
};

const defaultSale = (type, status) => {
  let sale = {};
  Object.values(SalesFields).forEach(field => (sale[field] = 0));

  sale[SalesFields.Status] = parseInt(status, 10);
  sale[SalesFields.StatusMerger] = type1Statuses.includes(status) ? 1 : 2;
  sale[SalesFields.TypeOfMeal] = type;

  return sale;
};

const defaultInfo = isSupper => {
  let info = {};
  Object.values(InfoFields).forEach(field => (info[field] = null));

  const numericFields = [
    InfoFields.ADAValue,
    InfoFields.ADMValue,
    InfoFields.AllowedFree,
    InfoFields.AllowedPaid,
    InfoFields.AllowedReduced,
    InfoFields.AttendanceFactor,
    InfoFields.DepositAmount,
    InfoFields.LabourHours,
    InfoFields.MAXFree,
    InfoFields.MAXPaid,
    InfoFields.MAXReduced,
    InfoFields.Misc1Amount,
    InfoFields.Misc2Amount,
    InfoFields.SiteDeposit,
  ];

  numericFields.forEach(field => (info[field] = 0));
  info[InfoFields.IsSupper] = isSupper;
  info[InfoFields.ClosingDate] = defaultDateFormat(moment());
  return info;
};

export const closeSchoolYearClosedDate = (fiscalYear, controlInfoActualDT) => {
  const defaultClosingDate = moment(`07/01/${fiscalYear - 1}`);

  return defaultClosingDate.isBefore(controlInfoActualDT, 'day')
    ? defaultClosingDate
    : moment(controlInfoActualDT);
};



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/helpers/EditDailyDepositHelpers.js